<template>
  <!-- 各产品卡片 盒子 一些判断逻辑也放进来，减少index代码量 -->
  <div>
    <div v-for="(product, index) in productList" :key="index" class="result-container">
      <div class="title-container" :class="{'is-long' : tabActive !== 'land'}">
        <img class="ems-post-logo" src="https://ump.ems.com.cn/newmail-resources/images/logo/post-ems-logo@3x.png">
        <span class="title-text" :class="{'green-text': ['标快', '快递包裹'].includes(product.name)}">{{ product.name }}</span>
      </div>
      <div v-if="Number(product.marAdjustFee) < 0 && !getTipsContent(product).length"
        class="tagBox-container">
        <span>限时促销</span>
        <i class="iconfont icon-arrow-down-solid"></i>
      </div>
      <div class="result-title title">
        <span v-if="tabActive ==='land' && +isPromise === 1 && !getTipsContent(product).length" class="promise-icon">承诺时效</span>
        <div class="title-primary">
          <p class="title-price">¥<span class="delivery-price">{{ getTotalFee(product)}}</span></p>
        </div>
        <!-- 有运费的标签 红色样式放前面 -->
        <div v-if="!getTipsContent(product).length" class="title-sub">
          <p v-if="!product.isCanInsured" class="tabs-text is-tip">此产品暂不支持保价</p>
          <p class="tabs-text">运费¥{{+product.realFee || '-'}}</p>
          <!-- 国际的其他费用 -->
          <template v-if="tabActive !== 'land' && product.otherFreeList">
            <p v-for="(free, freeIndex) in product.otherFreeList" :key="freeIndex" class="tabs-text">
              {{ free.label }}¥{{ +free.value }}
            </p>
          </template>
          <template v-if="product.isCanInsured">
            <p v-if="!getProtectPrice(product) && !isHideProtectTip(product)" class="tabs-text">建议保价</p>
            <p v-else-if="getProtectPrice(product)" class="tabs-text" :class="{'is-tip':isMaxSafeguardCost(product)}">
              <span>{{ `${tabActive ==='land' ? '基础保¥' : '保价¥'}` + getProtectPrice(product) }}</span>
              <span v-if="isMaxSafeguardCost(product)">{{`(此产品保价限额${product.maxSafeguardCost}万元)`}}</span>
            </p>
          </template>
          <p v-if="+weight >= product.maxWeight" class="tabs-text">最高可寄{{product.feeWeight/1000}}kg</p>
          <p v-else class="tabs-text">计费重量{{product.feeWeight/1000}}kg</p>
        </div>
        <!-- 无运费的标签（红） -->
        <div v-if="getTipsContent(product).length" class="title-sub">
          <p v-for="(tips) in getTipsContent(product)" :key="tips" class="tabs-text is-tip">
            {{tips}}
          </p>
        </div>
      </div>
      <div class="result-footer">
        <div class="result-desc">
          <p class="time-wrapper" v-if="tabActive ==='land' && +isPromise === 1">承诺{{promiseReceiveTime | promiseDateFormatter}}送达</p>
          <p class="time-wrapper" v-if="isShowReceiveTime(product)">预计{{product.receiveTime | dateformatTime}}前送达</p>
          <div class="is-tip" v-if="!isShowReceiveTime(product)">暂无预计送达时间</div>
          <template v-if="tabActive !== 'land'">
            <p class="time-wrapper" v-if="!getTipsContent(product).length && product.deadline">
              参考时效 {{product.deadline}} 天</p>
            <p class="desc-tip" v-else>{{ isNotPostCode ? '请输入原寄地和目的地邮编后进行查询时效' : '暂不支持时效标准查询' }}</p>
          </template>
          <p class="desc-tip" v-if="[1,2].includes(+product.collectionStatus)">{{product.collectionMessage2}}</p>
          <p class="desc-tip" v-else>{{ product.isPickupAvailable | pickupTipFilter(tabActive, product.productCode) }}</p>
          <p class="desc-tip" v-if="[0,1].includes(+product.collectionStatus) && !getTipsContent(product).length">
            首重({{product.startWeight/1000}}kg){{product.startMoney}}元，续重(每{{product.nextWeight}}g){{product.nextFee}}元</p>
        </div>
      </div>
      <!-- 即日的截邮时间提示 并且有显示运费才显示 -->
      <div class="tips-box" v-show="product.productCode === '111114300000191' && dayMailTimeTips && !getTipsContent(product).length">{{dayMailTimeTips}}</div>
    </div>
  </div>
</template>

<script>
import util from '@/plugin/util'
export default {
  components: {},
  props: {
    productList: { // 产品列表
      type: Array,
      default: () => {
        return []
      }
    },
    tabActive: { // tab类型 land sar int
      type: String,
      default: ''
    },
    isPromise: { // 是否承诺到达 国内
      type: [String, Number],
      default: ''
    },
    promiseReceiveTime: { // 承诺到达时间
      type: String,
      default: ''
    },
    dayMailTimeTips: { // 即日的截邮时间提示
      type: String,
      default: ''
    },
    isServer: { // 当前时间是否支持上门
      type: Boolean,
      default: false
    },
    isSameCity: { // 即日是否同城
      type: Boolean,
      default: false
    },
    isHsaDetail: { // 是否详细地址都填了（即日的显示）
      type: Boolean,
      default: false
    },
    isNotPostCode: { // 卡哈拉并且没填邮编
      type: Boolean,
      default: false
    },
    protectPrice: { // 用户填的保价
      type: [String, Number],
      default: ''
    },
    weight: { // 用户填的重量
      type: [String, Number],
      default: ''
    },
    goodsType: {
      type: [String, Number],
      default: ''
    },
    goodsLength: {
      type: [String, Number],
      default: ''
    },
    goodsWidth: {
      type: [String, Number],
      default: ''
    },
    goodsHeight: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
    }
  },
  filters: {
    // 是否支持上门/自寄提示语
    pickupTipFilter (value, tabActive, code) {
      // 即日和快包提示语特殊
      if (code === '111114300000191') {
        return '仅支持快递员上门取件，不提供自寄服务' // 即日
      } else if (code === '113124300000691') {
        return '不提供上门取件服务，需前往邮政营业网点自寄' // 快包
      }
      if (value && code !== '212105304600691') {
        return '支持快递员上门取件/服务点自寄'
      }
      if (tabActive !== 'land' && code === '212105304600691') { // e邮宝
        return '仅支持服务点自寄'
      }
      return '不提供上门取件服务，仅可自寄'
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    selectEvaluate (value) {
      this.$emit('selectEvaluate', value)
    },
    /**
     * 国内的保价前端计算，国际直接拿接口
     * item: 产品项
     * maxSafeguardCost: 最大保价声明，单位为万元
     * safeguardFeeRate: 保费根据声明价值转换倍率
    */
    getProtectPrice (item) {
      if (this.tabActive !== 'land') {
        // 国际的保价，因为各地区费率不一样，所以拿字段计算
        return Number(item.BJF || 0) + Number(item.BJSXZF || 0)
      }

      // 国内产品保价
      if (Number(this.protectPrice < 0) || +this.protectPrice === 0) {
        return ''
      }
      // 国内从前端计算改完显示资费接口返回的
      return Number(item.BJF || 0)
      // if (Number(this.protectPrice) <= 300) {
      //   return `1` // 最低1块保价
      // } else if (Number(this.protectPrice) > (item.maxSafeguardCost * 10000)) {
      //   let overPrice = (item.maxSafeguardCost * 10000) - 300
      //   let overFee = util.mineFixed(((overPrice * item.safeguardFeeRate) + 1), 1)
      //   return `${overFee}`
      // } else {
      //   let overPrice = Number(this.protectPrice) - 300
      //   let overFee = util.mineFixed(Number((overPrice * item.safeguardFeeRate) + 1), 1)
      //   return `${overFee}`
      // }
    },
    // 如果是寄港澳台寄国际且为e邮宝产品则不展示“建议保价”字段
    isHideProtectTip (item) {
      return this.tabActive !== 'land' && item.productCode === '212105304600691'
    },
    // 总费用（预估运费）=保价+运费，国际直接返回
    getTotalFee (item) {
      if (this.getTipsContent(item).length) {
        return '--'
      }
      if (!item.totalFee) {
        return '--'
      }
      if (this.tabActive !== 'land') {
      // 国际港澳台
        if (Number(this.protectPrice) > (item.maxSafeguardCost * 10000)) {
          // 如果超过保价限额，运费需要减去保价费
          let free = Number(item.totalFee) - Number(this.getProtectPrice(item))
          if (isNaN(free)) {
            return ''
          }
          return util.mineFixed(Number(free), 1)
        }
        return item.totalFee
      }

      // 国内 超出保价限额 按最高（控制资费接口的入参）
      // 标快可能有营销资费提示tag，费用是优惠后的
      return item.totalFee
      // 国内，前端自己算
      // if (!(+this.protectPrice)) {
      //   return item.totalFee
      // }
      // let num = Number(this.getProtectPrice(item)) + Number(item.totalFee)
      // if (isNaN(num)) {
      //   return ''
      // }
      // if (num.toString().length >= 5) {
      //   return util.mineFixed(Number(num), 2)
      // }
      // return num
    },
    // 是否显示预估时间
    isShowReceiveTime (item) {
      // 有时间 支持上门 非承诺 不限制收寄 无其他异常提示
      // 修复：不判断是否可以上门
      if (item.receiveTime && +this.isPromise === 0 && [0, 1].includes(+item.collectionStatus) && !this.getTipsContent(item).length) {
        return true
      }
      return false
    },
    // 是否超出保价限额
    isMaxSafeguardCost (item) {
      // 允许保价 有输入声明价值 并且超过保价限额
      if (item.isCanInsured && +this.protectPrice && Number(this.protectPrice) > (item.maxSafeguardCost * 10000)) {
        return true
      }
      return false
    },
    // 产品的显示逻辑，有异常提示则不显示运费等
    getTipsContent (item) {
      let tipsContent = []
      if (item && item.totalFee) {
        // 同城(即日不支持非同城),
        if (item.productCode === '111114300000191') {
          if (!this.isSameCity) {
            tipsContent.push('该路向暂未开通此业务')
          } else if (!this.isHsaDetail) {
            tipsContent.push('请输入详细地址查询运费时效')
          }
        }
        if (!item.goodsTypes.includes(this.goodsType)) {
          tipsContent.push('该路向暂未开通此业务') // 包裹不支持文件
        }
        // 物品重量 如果重量也按最大算（而非不展示费用），注释掉该判断
        if (item.maxWeight && (+this.weight > item.maxWeight)) {
          tipsContent.push(`${item.productName}不支持收寄${item.maxWeight}kg以上的物品`)
        }
        // 三边合计不超过300
        if (item.maxVolumeTotal) {
          if (item.productCode === '113124300000691' &&
          ((+this.goodsLength) + (+this.goodsWidth) + (+this.goodsHeight)) > item.maxVolumeTotal) {
            // 快包，不用2倍
            // tipsContent.push(`不支持长宽高合计超过${item.maxVolumeTotal}cm的物品收寄`)
            tipsContent.push(item.volumeOverSizeTip)
          } else if (item.productCode !== '113124300000691' &&
          (+this.goodsLength + (2 * +this.goodsWidth) + (2 * +this.goodsHeight)) > item.maxVolumeTotal) {
            tipsContent.push(item.volumeOverSizeTip)
          }
        }
        // 单边长度
        if (item.maxVolumeLength && this.estimateLength(item.maxVolumeLength)) {
          tipsContent.push(`${item.productName}体积长、宽、高三边不可大于${item.maxVolumeLength}cm`)
        }
        return tipsContent
      }
      // 调接口没有运费的情况
      tipsContent = ['该路向暂未开通此业务']
      return tipsContent
      // return {
      //   isShow: false,
      //   tipsContent,
      //   showTag: !tipsContent.length
      // }
    },
    // 长宽高单边限制判断是否超过num长度
    estimateLength (num) {
      return (+this.goodsLength) > num || (+this.goodsWidth) > num || (+this.goodsHeight) > num
    }
  } /* methods末 */
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
